export const API_ENDPOINT = {
  Login: {
    api: "/auth/v1/login",
    method:'POST'
  },
  Otp: {
    api: "/auth/v1/verifyOTP",
    method:'POST'
  },
  Faq:{
    api:"/admin-api/v1/faqs",
    sectionApi:"/admin-api/v1/faq-sections",
    subSectionApi: "/admin-api/v1/faq-sub-sections"
  },
  Registration:{
    api:"/auth/v1/register",
  },
  Trip:{
    api:"/trip-api/v1/trips",
    shareTripApi :"/trip-api/v1/share-trips"  
  },
  GoogleMap:{
    autocompleteApi:"/trip-api/v1/auto-complete",
    nearbysearch:"/trip-api/v1/nearbySearch-api",
    placeApi:"/trip-api/v1/place-api",
    directionApi:"/trip-api/v1/direction-api",
    geocodeApi:"/geocode/json",
    locationCheck:'/trip-api/v1/location-check'
  },
  Logout:{
    api:"/auth/v1/logout"
  },
  CustomerTrip:{
    rateCalculationApi:"/trip-api/v2/rate-calculation",
    rateCalculationRentalApi:"/trip-api/v1/rental-prices",
    tripCheckoutApi:"/trip-api/v1/trip-checkout",
    tripSlabApi:"/trip-api/v1/start-details",
    cancelTripApi:"/trip-api/v1/dummy-cancel-trips",
    cancelReasonApi:"/trip-api/v1/cancel-reasons",
    refundPriceApi:"/trip-api/v1/refund-prices",
    tripRentalApi:"/trip-api/v1/rental-bookings",
    rentalSlabApi:"/trip-api/v1/start-details"
  },
  Profile:{
    api:"/customer-api/v1/customer-profiles",
    verifyApi:"/customer-api/v1/customer-verify-profiles",
  },
  Payment:{
    api:"/trip-api/v1/payments",
    hashApi:"/trip-api/v1/payment-hash",
    paymentMethodApi: "/trip-api/v1/payment-methods"
  },
  PayU:{
   api:"/trip-api/v1/payment",
   payuResponse:"/confirmRide"
  },

  cashfree:{
    api:"/payment/v1/orders",
    verify:"/payment/v1/verify-orders"
  },

  coupon:{
    couponList:"/trip-api/v1/coupons",
    couponRate: "/trip-api/v2/rate-calculation",
    couponRental: "/trip-api/v1/rental-prices",
  }
}